import { useQuery } from 'react-query'

import { getLiveId, getPresenterToken } from '../../global/blocs/roomInfo'
import {
  type ApiResponse,
  HTTPMethod,
  request,
} from '../../global/api/legacyApi'

const CAM_CODE_QUERY_KEY = 'cam_code'
const TEN_MINUTES_MS = 10 * 60 * 1000

type CamCodeDTO = {
  camera_authentication: string
}

const useCamCodeQuery = () => {
  return useQuery({
    queryKey: [CAM_CODE_QUERY_KEY],
    queryFn: async (): Promise<string> => {
      const liveId = getLiveId()
      const presenterToken = getPresenterToken()

      const { data } = await request<ApiResponse<CamCodeDTO>>({
        url: '/api/2/live/webinar/connect',
        method: HTTPMethod.GET,
        data: {
          live_id: liveId,
          presenter_token: presenterToken,
          include_camera_authentication_p: 1,
        },
      })

      if (!data.camera_authentication) {
        throw new Error('Missing camera authentication code')
      }

      return data.camera_authentication
    },
    refetchInterval: TEN_MINUTES_MS,
    staleTime: TEN_MINUTES_MS,
    cacheTime: TEN_MINUTES_MS,
    refetchOnMount: 'always',
  })
}

export { useCamCodeQuery }
